import CapsuleBudget from "./CapsuleBudget";

export default CapsuleBudget;
